import { Controller } from "@hotwired/stimulus"

// Adds copy-to-clipboard buttons to code blocks inside the docs content. Handles
// both the styled `.code` component (which ships its own `.copy` button) and
// plain Markdown fenced blocks (Rouge's `pre.highlight`, for which a floating
// button is injected). Buttons are wired here rather than authored in markup, so
// any code block gets one for free. Timers are cleared on Turbo navigation.
export default class extends Controller {
  connect() {
    this.timers = new Set()

    this.element.querySelectorAll(".code .copy").forEach((button) => {
      if (button.dataset.copyReady) return
      button.dataset.copyReady = "true"
      this.#bind(button, () => button.closest(".code").querySelector("code"))
    })

    this.element.querySelectorAll("pre.highlight").forEach((pre) => {
      if (pre.dataset.copyReady) return
      pre.dataset.copyReady = "true"
      pre.classList.add("has-copy")
      const button = document.createElement("button")
      button.className = "copy copy-float"
      button.type = "button"
      button.textContent = "Copy"
      pre.append(button)
      this.#bind(button, () => pre.querySelector("code") || pre)
    })
  }

  disconnect() {
    this.timers.forEach((timer) => clearTimeout(timer))
    this.timers.clear()
  }

  #bind(button, getSource) {
    button.addEventListener("click", async () => {
      const source = getSource()
      if (!source) return
      try {
        await navigator.clipboard.writeText(source.innerText)
      } catch {
        return
      }
      const original = button.textContent
      button.textContent = "Copied"
      button.classList.add("done")
      const timer = setTimeout(() => {
        button.textContent = original
        button.classList.remove("done")
        this.timers.delete(timer)
      }, 1600)
      this.timers.add(timer)
    })
  }
}
